import * as React from 'react'
import { useLoaderData } from 'react-router-dom'

import { ExploreProductsSection } from 'components/explore-products-section/ExploreProductsSection'
import { Content } from 'sdk/components'

import { ALSASection } from './sections/alsa-section/ALSASection'
import { CustomizeDeploySection } from './sections/customize-deploy/CustomizeDeploySection'
import { GearsSection } from './sections/gears-section/GearsSection'
import { Hero } from './sections/hero/Hero'
import { GettingStartedSection } from './sections/getting-started/GettingStartedSection'

import classes from './PlatformPage.module.scss'

import type { PlatformPageLoaderData } from './interfaces'

export const PlatformPage: React.FC = () => {
  const { cmsContent } = useLoaderData() as PlatformPageLoaderData

  if (!cmsContent) {
    throw new Error('Platform CMS content missing')
  }

  return (
    <>
      <Hero content={cmsContent.hero} />
      <Content gap={150} className={classes.content}>
        <CustomizeDeploySection content={cmsContent.customizeDeploy} />
        <GearsSection content={cmsContent.gears} />
        <GettingStartedSection content={cmsContent.gettingStarted} />
      </Content>
      <ALSASection content={cmsContent.alsa} />
      <ExploreProductsSection
        className={classes.exploreSection}
        soundcoreTitle={cmsContent.exploreProducts.soundcoreTitle}
        soundcoreButtonText={cmsContent.exploreProducts.soundcoreButtonText}
        soundscapeTitle={cmsContent.exploreProducts.soundscapeTitle}
        soundscapeButtonText={cmsContent.exploreProducts.soundscapeButtonText}
      />
    </>
  )
}
